<template>
  <div class="my">
    <nav-bar
      fixed
      z-index="99"
      title="我的游戏"
      left-text="返回"
      left-arrow
      placeholder
      @click-left="$router.push('/user')"
    />
    <div class="my-box">
      <div class="my-box-top">
        <div class="my-box-top-left">
          <div class="my-box-top-left-choose">
            <div>状态</div>
            <div style="margin-left: 0.1rem">
              <NfDropdownMenu
                width="1.5rem"
                :value.sync="query.status"
                :options="gameStatusList"
              ></NfDropdownMenu>
            </div>
          </div>
          <div class="my-box-top-left-choose">
            <div>类型</div>
            <div style="margin-left: 0.1rem">
              <NfDropdownMenu
                width="1.5rem"
                :value.sync="query.gameType"
                :options="gameTypeList"
              ></NfDropdownMenu>
            </div>
          </div>
        </div>
        <div class="my-box-top-right" v-if="userCategory == 2">
          <Icon name="plus"></Icon>
          <div @click="newGame" class="my-box-top-right-btn">新建游戏</div>
        </div>
      </div>
      <div class="my-box-list" ref="container">
        <template v-if="gameList.length > 0">
          <div>
            <template v-for="item in gameList">
              <nf-card class="my-box-list-item" :key="item.gameId">
                <div class="my-box-list-item-box" @click="goGameDetail(item)">
                  <!-- <div class="my-box-list-item-box-item">
                    <div>游戏名称：{{ item.gameName || "暂无" }}</div>
                  </div> -->
                  <div class="my-box-list-item-box-item">
                    <!-- <div>
                      游戏类型：
                      <span v-if="item.gameType === 1">单人游戏</span>
                      <span v-if="item.gameType === 2">多人游戏</span>
                      <span v-if="item.gameType === 3">家庭团体游戏</span>
                    </div> -->
                    <div>
                      <div>
                        游戏名称：
                        <span>{{ item.gameName || "暂无" }}</span>
                      </div>
                    </div>
                    <div>
                      游戏状态：
                      <!-- 状态0未开始 1进行中 2已结束 -->
                      <span v-if="item.gameStatus === 0">未开始</span>
                      <span v-if="item.gameStatus === 1">进行中</span>
                      <span v-if="item.gameStatus === 2">已结束</span>
                    </div>
                  </div>
                  <div class="my-box-list-item-box-item">
                    游戏类型：
                    <template v-if="item.gameType === 1">1对1游戏</template>
                    <template v-if="item.gameType === 2">1对多游戏</template>
                    <template v-if="item.gameType === 3">1对家庭游戏</template>
                  </div>
                  <div class="my-box-list-item-box-item">
                    <div>参与轮次：{{ item.roundNums }}次</div>
                  </div>

                  <div
                    class="my-box-list-item-box-item"
                    v-if="userCategory == 1"
                  >
                    <div>教练名称：{{ item.coachName }}</div>
                  </div>
                  <div class="my-box-list-item-box-item">
                    <div>开始时间：{{ formatDate(item.createTime) }}</div>
                    <!-- <NfButton
                      padding="0.05rem"
                      width="20%"
                      fontSize="0.2rem"
                      @click.native="goGameDetail(item)"
                      >查看详情</NfButton
                    > -->
                    <div
                      @click.stop="copyLink(item)"
                      style="width: 20%"
                      v-if="userCategory == 2"
                    >
                      <NfButton padding="0.05rem" width="100%" fontSize="0.2rem"
                        >复制链接</NfButton
                      >
                    </div>
                  </div>
                </div>
              </nf-card>
            </template>

            <Loading v-if="gameList.length >= 10" :loading="loading"></Loading>
          </div>
        </template>
        <template v-else>
          <Empty>暂无数据</Empty>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon, List, Cell, NavBar, Empty, List as VanList } from "vant";
import { getGameList, getRoundConfig } from "@/api/game";
import NfCard from "@/components/game-ui/NfCard.vue";
import NfButton from "@/components/game-ui/NfButton.vue";
import debounce from "lodash.debounce";
import NfDropdownMenu from "@/components/game-ui/NfDropdownMenu.vue";
import Loading from "@components/Loading";
import { mapGetters } from "vuex";

export default {
  components: {
    Icon,
    NfCard,
    NfButton,
    List,
    Cell,
    NavBar,
    NfDropdownMenu,
    Empty,
    VanList,
    Loading,
  },
  computed: mapGetters(['userInfo']),
  data() {
    return {
      gameList: [],
      gameStatusList: [
        { text: "全部", value: null },
        { text: "未开始", value: 0 },
        { text: "进行中", value: 1 },
        { text: "已结束", value: 2 },
      ],
      gameTypeList: [
        { text: "全部", value: null },
        { text: "1对1游戏", value: 1 },
        { text: "1对多游戏", value: 2 },
        { text: "1对家庭游戏", value: 3 },
      ],
      page: {
        page: 1,
        size: 10,
      },
      query: {
        status: null,
        gameType: null,
      },
      loading: false,
      userCategory: this.$route.query.userCategory || 1,
    };
  },
  mounted() {
    this.getGameList();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.onLoadList();
    });
  },
  methods: {
    getGameList() {
      const data = {
        userCategory: this.userCategory,
        ...this.page,
        status: this.query.status !== null ? this.query.status : undefined,
        gameType:
          this.query.gameType !== null ? this.query.gameType : undefined,
      };
      if (this.loading) {
        return;
      }
      this.loading = true;
      getGameList(data)
        .then((res) => {
          this.loading = false;
          if (res.success) {
            if (this.page.page === 1) {
              this.gameList = res.data;
            } else {
              this.gameList.push(...res.data);
            }

            if (this.page.page > 1 && res.data.length == 0) {
              this.page.page--;
            }
          } else {
            if (this.page.page > 1) {
              this.page.page--;
            }
          }
        })
        .catch(() => {
          this.loading = false;
          if (this.page.page > 1) {
            this.page.page--;
          }
        });
    },
    // 13位时间戳格式化
    formatDate(timestamp) {
      const date = new Date(timestamp);
      const Y = date.getFullYear() + "/";
      const M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "/";
      const D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      const h =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      const m =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      const s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    },
    onLoadList: debounce(function () {
      if (this.loading) return;
      this.page.page++;
      this.getGameList();
    }, 500),
    // 新建游戏
    newGame() {

      if(this.userInfo.cardStatus === 0){
        this.$dialog.toast({ mes: "当前卡牌教练还在审核，请审核通过后再次创建游戏" });
        return;
      }

      this.$router.push({
        path: "/game/apply",
      });
    },
    // 查看详情
    goGameDetail(item) {
      // 教练
      if (this.userCategory == 2) {
        // 游戏未开始
        if (item.gameStatus == 0) {
          this.$router.push({
            path: "/game/choose",
            query: {
              gameId: item.gameId,
            },
          });
        } else {
          this.$router.push({
            path: "/game/discus",
            query: {
              gameId: item.gameId,
            },
          });
        }

        return;
      } else if (this.userCategory == 1) {
        if (item.gameStatus == 0) {
          this.$router.push({
            path: "/game/choose",
            query: {
              gameId: item.gameId,
            },
          });
        } else {
          this.$router.push({
            path: "/game/start",
            query: {
              gameId: item.gameId,
            },
          });
        }
      }
    },
    // 复制链接
    copyLink(item) {
      const input = document.createElement("input");
      input.setAttribute("readonly", "readonly");
      if (item.password) {
        input.setAttribute(
          "value",
          `游戏链接：${item.gameUrl}  游戏密码：${item.password}`
        );
      } else {
        // input.setAttribute("value", item.gameUrl);
        input.setAttribute("value", `${item.gameUrl}`);
      }
      input.style.position = "absolute";
      input.style.left = "-9999px";
      document.body.appendChild(input);
      input.select();
      input.setSelectionRange(0, 9999);
      if (document.execCommand("copy")) {
        document.execCommand("copy");
      }
      this.$dialog.message("复制成功");
    },
  },
  watch: {
    query: {
      handler() {
        this.page.page = 1;
        this.getGameList();
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.my {
  background: rgb(172, 185, 233);
  // background: url(~@/assets/game/bg.png);

  &-box {
    width: 100%;
    height: 100%;

    border-top: solid 1px #333;
    background-color: #fff;
    padding: 0.2rem 0.3rem;
    font-size: 0.25rem;

    &-top {
      display: flex;
      justify-content: space-between;
      align-items: center;

      &-left {
        display: flex;

        &-choose {
          display: flex;
          align-items: center;
          margin-right: 0.1rem;
        }
      }

      &-right {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.35rem;
        color: #7b93e9;
        font-weight: bold;
        font-family: STHeiti;

        &-btn {
          // font-size: 0.23rem;
        }
      }
    }

    &-list {
      width: 100%;

      &-item {
        margin: 0.1rem 0;

        &-box {
          &-item {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
        }
      }
    }
  }
}

::v-deep .van-nav-bar {
  background-color: rgb(172, 185, 233) !important;
}
</style>
